import * as React from "react";
import { SubGroupConfiguration } from "../../../../data";

export class GroupingDropdown extends React.PureComponent<{
    handler: Function,
    dict: any,
    subGroupBy: SubGroupConfiguration
    isDesktop: boolean
}, {}> {
    private filterBox: React.RefObject<HTMLDivElement>;
    private wrap: React.RefObject<HTMLDivElement>;

    constructor(props) {
        super(props);
        this.filterBox = React.createRef();
        this.wrap = React.createRef();
    }

    handleClick(event: Event) {
        if (this.filterBox.current) {
            this.filterBox.current.classList.add("isHidden");
        }
    }

    componentDidMount() {
        window.addEventListener("click", this.handleClick.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener("click", this.handleClick);
    }

    /* istanbul ignore next */
    toggleOptions() {
        this.wrap.current && this.wrap.current.classList.toggle("rj-ev-list__gr-dropdown--active");
        this.filterBox.current && this.filterBox.current.classList.toggle("isHidden");
    }

    selectOption(ev, newOption: SubGroupConfiguration) {
        this.toggleOptions();
        this.props.handler(newOption);
    }

    renderDesktopDropdown() {
        return (
            <div id="rj-ev-list__gr-dropdown__wrap" className="rj-ev-list__gr-dropdown__wrap" data-uat="div-ev-list-gr-dropdown-wrap" ref={this.wrap}>
                <label className="rj-ev-list__gr-dropdown__label" onClick={(ev) => { ev && ev.stopPropagation(); this.toggleOptions(); }} data-uat="label-ev-list-gr-dropdown-label">
                    <span className="icon i-o-ev-filter i-12"></span>
                </label>

                <div className={`rj-ev-list__gr-dropdown__options-holder isHidden`} data-uat="div-ev-list-gr-dropdown-options-holder" ref={this.filterBox}>
                    <div className="rj-ev-list__gr-dropdown__option rj-ev-list__gr-dropdown__option-league" onClick={(ev) =>{ ev && ev.stopPropagation(); this.selectOption(ev, SubGroupConfiguration.League)}} data-uat="div-ev-list-gr-dropdown-option-league">
                        {`${this.props.dict.SortBy} ${this.props.dict.League}`}
                    </div>
                    <div className="rj-ev-list__gr-dropdown__option rj-ev-list__gr-dropdown__option-time" onClick={(ev) =>{ ev && ev.stopPropagation(); this.selectOption(ev, SubGroupConfiguration.Time)}} data-uat="div-ev-list-gr-dropdown-option-time">
                        {`${this.props.dict.SortBy} ${this.props.dict.Time}`}
                    </div>
                </div>
            </div>
        );
    }

    renderMobileDropdown() {
        return (
            <div className="rj-ev-list__gr-dropdown__wrap" data-uat="div-ev-list-gr-dropdown-wrap">
                <label className="rj-ev-list__gr-dropdown__label" data-uat="label-ev-list-gr-dropdown-label">
                    <span className="icon i-o-ev-filter i-12"></span>
                </label>

                <select className={`rj-ev-list__gr-dropdown__select`} onChange={(ev) => { ev && ev.stopPropagation(); this.selectOption(ev, ev.target.value as SubGroupConfiguration) }} defaultValue={this.props.subGroupBy} data-uat="select-ev-list-gr-dropdown-select">
                    <option className="rj-ev-list__gr-dropdown__select-option" data-uat="option-ev-list-gr-dropdown-select-option-league" value={SubGroupConfiguration.League}>
                        {`${this.props.dict.SortBy} ${this.props.dict.League}`}
                    </option>
                    <option className="rj-ev-list__gr-dropdown__select-option" data-uat="option-ev-list-gr-dropdown-select-option-time" value={SubGroupConfiguration.Time}>
                        {`${this.props.dict.SortBy} ${this.props.dict.Time}`}
                    </option>
                </select>
            </div>
        );
    }

    render() {
        return (
            this.props.isDesktop
                ? this.renderDesktopDropdown()
                : this.renderMobileDropdown()
        )
    }
}